import { login, getPublicKey, getUserType } from '@/request';
import { encrypt, encryptRsa } from '@/utils/encrypt';
import { localSet, localGet, localRemove } from '@/utils';
import Cookie from 'js-cookie';
import { useRouter } from 'vue-router'

const router = useRouter()
export default {
  namespaced: true,
  state: {
    publicKey: '',
    username: localGet('username') || '',
    userType: localGet('userType') || '',
    supUserId: localGet('supUserId') || ''
  },
  mutations: {
    setPublicKey(state, publicKey) {
      state.publicKey = publicKey;
    },
    setUsername(state, username) {
      state.username = username;
      localSet('username', username);
    },
    setUserType(state, type) {
      state.userType = Number(type);
      localSet('userType', type);
    },
    setSupUserId(state, supUserId) {
      state.supUserId = Number(supUserId);

      localSet('supUserId', supUserId);
    }
  },
  actions: {
    async login({ commit, state, dispatch }, payload) {
      const data = await getPublicKey();
      commit('setPublicKey', data.data.pubKey);
      const password = encrypt(payload.pwd);
      const sign = encryptRsa(state.publicKey);
      const form = {
        username: payload.username,
        sign,
        password,
        __repeat: true
      };
      if (state.publicKey) {
        return login(form).then((res) => {
          if (res?.success) {
            dispatch('initLoginState', payload);
          }
          return res;
        });
      }

      return Promise.reject();
    },
    initLoginState({ commit }, payload) {
      commit('setUsername', payload.username);
      commit('router/updateTabsList', { tab: [], type: 'clear' }, { root: true });
      getUserType().then((userTypeRes) => {
        if (userTypeRes.success) {
          commit('setUserType', userTypeRes.data.userType);
          commit('setSupUserId', userTypeRes.data.supUserId);
        }
      });
    },
    logout({ commit, dispatch }) {
      Cookie.remove('userInfo');
      commit('setUsername', '');
      localRemove('username');
      localRemove('pwd');
      commit('setUserType', '');
      commit('setSupUserId', '');
      commit('setPublicKey', '');
      dispatch('router/clearState', null, { root: true });
    }
  }
};
